import { BoxApnItem } from '@/box/interface'
import { getFormatMessage } from '@/utils/utils'
import { Button, Col, Form, Input, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { Title } from '../shared/Title'

export interface BoxDetailApnProps {
  title?: boolean
  editItem?: BoxApnItem
  disabled?: boolean
  onSave?: (apnItem: BoxApnItem) => void
}

export const BoxDetailApn: React.FC<BoxDetailApnProps> = (
  props: BoxDetailApnProps
) => {
  const { title, disabled, editItem, onSave } = props
  const formatMessage = getFormatMessage()
  const [apnForm] = Form.useForm<BoxApnItem>()
  const [loading, setLoading] = useState<boolean>(false)
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  }

  const handleApnSave = async () => {
    if (!onSave) return
    try {
      const value = await apnForm.validateFields()
      setLoading(true)
      await onSave(value)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (editItem) {
      apnForm.setFieldsValue(editItem)
    }
  }, [editItem])

  return (
    <Form {...formItemLayout} form={apnForm} labelAlign='right'>
      {title && (
        <Title
          level={4}
          extra={
            <Button
              type='primary'
              disabled={disabled}
              loading={loading}
              onClick={handleApnSave}
            >
              {formatMessage({ id: 'app.box.detail.edit.save' })}
            </Button>
          }
        >
          {formatMessage({ id: 'app.box.detail.edit.cellular' })}
        </Title>
      )}
      <Row>
        <Col span={8}>
          <Form.Item
            name='apn'
            label='APN'
            rules={[
              {
                required: true,
                message: formatMessage({
                  id: 'app.box.detail.edit.apn.message'
                })
              }
            ]}
          >
            <Input disabled={disabled} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name='userName'
            label={formatMessage({ id: 'app.box.detail.edit.userName' })}
          >
            <Input disabled={disabled} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name='password'
            label={formatMessage({ id: 'app.box.detail.edit.password' })}
          >
            <Input disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            name='dialing'
            label={formatMessage({ id: 'app.box.detail.edit.dialing' })}
          >
            <Input disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}
